import React, { Component } from "react";
import './SheetMenu.css'
import SheetMenu from './SheetMenu'

export class SheetMenuContainer extends Component {
	constructor(props) {
		super(props);
		const ProductName = props.ProductName;
		const FullProductPath = props.FullProductPath;
		const datasetDetails = props.datasetDetails;
		const TitleViewField = props.TitleViewField;
		const FieldArray = props.FieldArray;
		const DetailFields = props.DetailFields;
		const appURL = props.appURL;
		this.state = {
			ViewObject: {},
			datasetDetails: datasetDetails,
			TitleViewField: TitleViewField,
			FieldArray: FieldArray,
			DetailFields: DetailFields,
			datasetID: props.datasetID,
			ProductName: ProductName,
			FullProductPath: FullProductPath,
			loading: true,
			appURL: appURL,
			selectedSheetID: props.selectedSheetID
		};
		this.handleOnClick = this.handleOnClick.bind(this);
		this.handleMouseDown = this.handleMouseDown.bind(this);
	}
	componentDidUpdate(prevProps, prevState){
		if (prevProps.selectedSheetID !== this.props.selectedSheetID){
			this.setState({
				selectedSheetID: this.props.selectedSheetID
			})
		}
	}
	handleOnClick = (e) => {
		this.setState({
			selectedSheetID: e.target.id
		})
		e.stopPropagation();
	  }
	handleMouseDown(e) {
		e.stopPropagation();
	  }
	  render (){
		return (
			<div className="SheetMenuContainer">
				<SheetMenu ProductName={this.state.ProductName}
					FullProductPath={this.state.FullProductPath} 
					appURL={this.state.appURL} 
					datasetID={this.state.datasetID} 
					handleOnClick={this.handleOnClick}
					selectedSheetID={this.state.selectedSheetID}
					datasetDetails={this.state.datasetDetails}
					FieldArray={this.state.FieldArray}
					DetailFields={this.state.DetailFields}
					TitleViewField={this.state.TitleViewField}
					/>
			</div>
		);
	}
}